import { api, LightningElement } from "lwc";
import type { HeaderSummary } from "./types";

export type { HeaderSummary };
export default class CourseDetailHeader extends LightningElement {
  static renderMode = "light";
  @api headersummary: HeaderSummary = null!;

  @api joinButtonDetail={
    id: "1",
    buttonLabel: {
        value: "",
        label: ""
    },
    variant: 'primary',
    size: 'default',
    showWesButton: true
  };

  @api cancelButtonDetail={
    id: "2",
    buttonLabel: {
        value: "",
        label: ""
    },
    type: "BORDER",
    icon: {}
  };

  private setBackgroundImage() {
    let heroBg = this.querySelector(".hero--bg") as HTMLElement;
    if (this.headersummary?.backgroundImageUrl) {
      heroBg.style.backgroundImage = `url(${this.headersummary?.backgroundImageUrl})`;
    }
  }

  buttonHandler() {
    this.dispatchEventMethod("buttonclick",{ classId: this.headersummary?.id, name: this.joinButtonDetail.buttonLabel.value });
  }

  cancelClassHandler() {
    this.dispatchEventMethod("buttonclick",{ classId: this.headersummary?.id, name: this.cancelButtonDetail.buttonLabel.value });
  }

  dispatchEventMethod(eventName: string, eventDetail: { classId: string, name: string}){
    this.dispatchEvent(
        new CustomEvent(eventName, {
            detail: eventDetail,
        })
    );
  }
  
  private get showCancelClass() {
      return this.headersummary?.cancellationFlag === "ALLOWED" ? true : false;
  }

  private get showCancelClassDisabled() {
      return this.headersummary?.cancellationFlag === "DISABLED" ? true : false;
  }
  private get isDisabled() {
    return this.headersummary?.availableToJoin === true ? false : true;
  }

  private get hasHeaderSummary() {
    return this.headersummary !== null;
  }

  private get backgroundImageUrl() {
    return this.headersummary?.backgroundImageUrl;
  }

  private get courseTitle() {
    return this.headersummary?.courseTitle;
  }

  private get description() {
    return this.headersummary?.description;
  }

  private get showjoin() {
    if(this.headersummary?.joinNowButton.label !== undefined){
      this.createButtonData();
    }
    return this.headersummary?.joinNowButton.label !== undefined;
  }
  private get tags() {
    return this.headersummary?.tags;
  }

  renderedCallback() {
    this.setBackgroundImage();
    let roleIcon = this.querySelector(".icon-container") as HTMLElement;
    if(roleIcon !== null) {
      roleIcon.style.backgroundColor = this.headersummary.tags[0].color as string;
    }
  }

  createButtonData(){
    if(this.headersummary?.joinNowButton.label !== undefined && this.headersummary?.cancelClassButton.label !== undefined){
     
      this.joinButtonDetail.buttonLabel.label = this.headersummary?.joinNowButton.label;
      this.joinButtonDetail.buttonLabel.value = this.headersummary?.joinNowButton.value;
  
      this.cancelButtonDetail.buttonLabel.label = this.headersummary?.cancelClassButton.label;
      this.cancelButtonDetail.buttonLabel.value = this.headersummary?.cancelClassButton.value;
    }
   
  }
}